import api from './api'
import Swal from 'sweetalert2'
let service = {}

service.deleteClient = function (id) {
  return api.delete(`api/client/${id}`).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}


service.ocultarVenta = function (id, state) {
  return api.put(`api/sale/hide/${id}`,{state}).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
  })
}

service.verifyRol = function (id) {
  return api.post('api/users/verifyRole', id).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
  })
}




service.registrarVenta = function (vehiculo) {
  return api.post('/api/sale/create', vehiculo).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}

service.vehiculoByFilter = function (filter) {
  return api.post('/api/vehicle/getByFilters', filter).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}
service.vehiculo = function () {
  return api.get('/api/vehicle').then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}
service.vehiculoNuevo = function (vehiculo) {
  return api.post('/api/vehicle/create', vehiculo).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}
service.vehiculoEditar = function (id, vehiculo) {
  return api.put(`/api/vehicle/${id}`, vehiculo).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}

service.cliente = function () {
  return api.get('/api/client').then(res => res.data).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
  })
}
service.marcaPaginada = function (filtros) {
  return api.get('/api/brand/paginated', { params: filtros }).then(res => res.data).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}
service.clientePaginado = function (filtros) {
  return api.get('/api/client/paginated', { params: filtros }).then(res => res.data).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}
service.clienteNuevo = function (cliente) {
  return api.post('/api/client/create', cliente).then(res => res.data).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}
service.clienteEditar = function (id, cliente) {
  return api.put(`/api/client/${id}`, cliente).then(res => res.data).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}


service.categoria = function () {
  return api.get('/api/productCategory').then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
  })
}
service.categoriaNuevo = function (categoria) {
  return api.post('/api/productCategory/create', categoria).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
  })
}
service.categoriaEditar = function (id, categoria) {
  return api.put(`/api/productCategory/${id}`, categoria).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
  })
}

service.productosYServicios = function (filtro) {
  return api.post('/api/product/sales/products-services-filters', filtro).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
  })
}

service.producto = function () {
  return api.get('/api/product').then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}
service.productoNuevo = function (producto) {
  return api.post('/api/product/create', producto).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}
service.productoEditar = function (id, producto) {
  return api.put(`/api/product/${id}`, producto).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}
service.tipo_pagos = function () {
  return api.get('/api/paymentType').then(res => res.data).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
  })
}
service.tipo_pagosNuevo = function (pago) {
  return api.post('/api/paymentType/create', pago).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
  })
}
service.inventario = function (options) {
  const { page = 1, itemsPerPage = 10,busqueda = "" } = options
  return api.get(`/api/inventory/?page=${page}&limit=${itemsPerPage}&busqueda=${busqueda}`).then(res => res.data).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}
service.inventarioEditar = function (id, producto) {
  return api.put(`/api/inventory/${id}`, producto).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}

service.servicio = function () {
  return api.get('/api/service').then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}
service.servicioNuevo = function (servicio) {
  return api.post('/api/service/create', servicio).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}
service.servicioEditar = function (id, servicio) {
  return api.put(`/api/service/${id}`, servicio).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}
service.ventas = function (options) {
  const { page = 1, itemsPerPage = 10, busqueda = "" } = options
  return api.get(`/api/sale?page=${page}&limit=${itemsPerPage}&busqueda=${busqueda}`).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}

service.ventaDetalle = function (id) {
  return api.get(`/api/sale/${id}`).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
  })
}
service.ventaCancelar = function (id) {
  return api.put(`/api/sale/cancel/${id}`).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw err
  })
}
service.registrarEntradaNuevo = function (orderService) {
  return api.post('/api/orderService/createOrderAndRegister', orderService).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}
service.registrarEntradaExistente = function (orderService) {
  return api.post('/api/orderService/createOrderExistClient', orderService).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}
service.orden = function () {
  return api.get('/api/orderService').then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}
service.ordenFiltro = function (filter) {
  return api.post('/api/orderService/getByFilters', filter).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
  })
}
// service.registrarEntradaExistente = function(orderService){
//   return api.post('/api/orderService/create', orderService).then(res => res)
// }
service.ordenEditar = function (id, orderService) {
  return api.put(`/api/orderService/${id}`, orderService).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}

service.ordenEditarImg = function (id, img) {
  return api.put(`/api/orderService/image/${id}`, img).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
  })
}

service.guardarOrdenDigital = async (data) => {
  return api.post('/api/orderService/firmar', data).then(res => res.data).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
  })
}

service.descargarOrdenDigital = async (id) => {
  return api.get(`/api/orderService/pdf/${id}`, { responseType: 'arraybuffer' }).then(res => res.data).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
  })
}

service.modeloByFilter = function (filter) {
  return api.post('/api/model/getByFilters', filter).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}
service.modeloPaginado = function (filtros) {
  return api.get('/api/model/paginated', { params: filtros }).then(res => res.data).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}
// Aviso al capturar: no interrumpe; si falla, el backend valida al guardar
service.modeloDuplicado = function (nombre, excluir) {
  const params = excluir ? { nombre, excluir } : { nombre }
  return api.get('/api/model/duplicate', { params }).then(res => res.data.duplicado || null).catch(() => null)
}
// Todos los modelos activos con sus autos (para elegir cuál fusionar con cuál)
service.modeloOpciones = function () {
  return api.get('/api/model/options').then(res => res.data).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}
service.fusionarModelo = function (id, destino) {
  return api.post(`/api/model/${id}/merge`, { destino }).then(res => res.data).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}
service.modelo = function () {
  return api.get('/api/model').then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}
service.modeloNuevo = function (modelo) {
  return api.post('/api/model/create', modelo).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}
service.modeloEditar = function (id, modelo) {
  return api.put(`/api/model/${id}`, modelo).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}

service.eliminarModelo = function (id) {
  return api.delete(`/api/model/${id}`).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}

service.almacen = function () {
  return api.get('/api/warehouse').then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
  })
}
service.almacenNuevo = function (modelo) {
  return api.post('/api/warehouse/create', modelo).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
  })
}
service.almacenEditar = function (id, modelo) {
  return api.put(`/api/warehouse/${id}`, modelo).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
  })
}
service.compra = function (options) {
  const { page = 1, itemsPerPage = 10, busqueda = "" } = options
  return api.get(`/api/purchase?page=${page}&limit=${itemsPerPage}&busqueda=${busqueda}`).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}
service.compraNuevo = function (modelo) {
  return api.post('/api/purchase/create', modelo).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}
service.compraEditar = function (id, modelo) {
  return api.put(`/api/purchase/${id}`, modelo).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}
service.compraCancelar = function (id) {
  return api.put(`/api/purchase/cancel/${id}`).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}

service.marcaByFilter = function (filter) {
  return api.post('/api/brand/getByFilters', filter).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
  })
}
service.marca = function () {
  return api.get('/api/brand').then(res => res.data).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}
service.marcaNuevo = function (marca) {
  return api.post('/api/brand/create', marca).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}
service.marcaEditar = function (id, marca) {
  return api.put(`/api/brand/${id}`, marca).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}

service.borrarMarca = function (id) {
  return api.delete(`/api/brand/${id}`).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}

service.proveedor = function () {
  return api.get('/api/provider').then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
  })
}
service.proveedorNuevo = function (proveedor) {
  return api.post('/api/provider/create', proveedor).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}
service.proveedorEditar = function (id, proveedor) {
  return api.put(`/api/provider/${id}`, proveedor).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}

service.proveedorEliminar = function (id) {
  return api.delete(`/api/provider/${id}`).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}

// Catálogo de proveedores: página, búsqueda y orden (compras, última compra)
service.proveedorPaginado = function (filtros) {
  return api.get('/api/provider/paginated', { params: filtros }).then(res => res.data).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}


service.sucursal = function () {
  return api.get('/api/branch').then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}
service.sucursalNuevo = function (sucursal) {
  return api.post('/api/branch/create', sucursal).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}
service.sucursalEditar = function (id, sucursal) {
  return api.put(`/api/branch/${id}`, sucursal).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}


service.empleadoByFilter = function (filter) {
  return api.post('/api/employee/getByFilters', filter).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}
service.empleado = function () {
  return api.get('/api/employee').then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
  })
}
service.empleadoNuevo = function (empleado) {
  return api.post('/api/employee/create', empleado).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}
service.empleadoEditar = function (id, empleado) {
  return api.put(`/api/employee/${id}`, empleado).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}

// Catálogo de empleados: página, búsqueda, puesto y orden (servicios del último año)
service.empleadoPaginado = function (filtros) {
  return api.get('/api/employee/paginated', { params: filtros }).then(res => res.data).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}
service.puestos = function () {
  return api.get('/api/position').then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
  })
}

service.roles = function () {
  return api.get('/api/role').then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
  })
}

service.usuario = function () {
  return api.get('/api/users').then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}
service.usuarioNuevo = function (usuario) {
  return api.post('/api/users/register', usuario).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}
service.usuarioEditar = function (id, usuario) {
  return api.put(`/api/users/${id}`, usuario).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
  })
}

// Catálogo de usuarios: página, búsqueda y orden; nunca trae la contraseña
service.usuarioPaginado = function (filtros) {
  return api.get('/api/users/paginated', { params: filtros }).then(res => res.data).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}
service.servicioHistorialEditar = function (servicio) {
  return api.put(`/api/serviceHistory/updateAll`, servicio).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
  })
}
service.zeus = function () {
  return api.get('/api/orderHistoryZeus').then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
  })
}
service.citas = function () {
  return api.get('/api/date').then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
  })
}

service.citaPorId = function (id) {
  return api.get(`/api/date/${id}`).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
  })
}

service.citaByFilters = function (where) {
  return api.post('/api/date/getByFilters', where).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
  })
}

service.citaNueva = function (cita) {
  return api.post('/api/date/create', cita).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
  })
}

service.citaEditar = function (id, cita) {
  return api.put(`/api/date/${id}`, cita).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
  })
}

service.RFC = function () {
  return api.get('/api/invoice-reciver').then(res => res.data).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}


service.ConceptoPago = function () {
  return api.get('/api/invoice/cfdi').then(res => res.data).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}
service.MetodosPago = function () {
  return api.get('/api/invoice/metodosPago').then(res => res.data).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
  })
}
service.FormaPago = function () {
  return api.get('/api/invoice/formasPago').then(res => res.data).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
  })
}
service.ClaveProducto = function () {
  return api.get('/api/invoice/claveProductos').then(res => res.data).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
  })
}
service.UnidadMedida = function () {
  return api.get('/api/invoice/unidadesMedida').then(res => res.data).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
  })
}
service.crearFactura = function (factura) {
  return api.post('/api/invoice/create', factura).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}
service.Facturas = function (options) {
  const { page, itemsPerPage,receptor_id = null } = options
  return api.get(`/api/invoice/?page=${page}&limit=${itemsPerPage}&busqueda=${receptor_id}`).then(res => res.data).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
  })
}

service.cancelarFactura = function (factura) {
  return api.post('/api/invoice/cancel?id=' + factura).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}
service.reenviarFactura = function (factura) {
  return api.post('/api/invoice/reenviar?id=' + factura).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}
service.folios = function (sucursal) {
  return api.get(`/api/invoice/folios-disponibles?idSucursal=${sucursal}`).then(res => res.data).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
  })
}

service.crearFacturaOrden = function (factura) {
  return api.post('/api/invoice/order/create', factura).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}

service.enviarFactura = function (factura) {
  return api.post('/api/invoice/sendMail', factura).then(res => res).catch(err => {
    console.log(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
     throw(err)
  })
}

service.abrirCaja = function (corte) {
  return api.post('/api/saleBox/openSaleBox', corte).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}

service.calcularCaja = function (corte) {
  return api.post('/api/saleBox/calcSaleBoxCut', corte).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
  })
}

service.registrarCorte = function (corte) {
  return api.post('/api/saleBox/registerSaleBoxCut', corte).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
    throw(err)
  })
}

service.cajaAbierta = function (usuario, caja) {
  return api.get(`/api/saleBox/isOpenBox?user=${usuario}&saleBoxId=${caja}`).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
  })
}

service.cajas = function () {
  return api.get(`/api/saleBox/`).then(res => res).catch(err => {
    console.error(err)
    Swal.fire({
      title: 'Atención!',
      text: err.data.message,
      icon: 'error',
      confirmButtonText: 'Enterado'
    })
  })
}

export default service
